import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export type VariantStyle = 'primary' | 'secondary' | 'text';

export type StyledButtonProps = {
  active?: boolean;
  variantStyle?: VariantStyle;
  isModalButton?: boolean;
};

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !['variantStyle'].includes(prop as string) && prop !== 'fullWidth' && prop !== 'active' && prop !== 'isModalButton',
})<StyledButtonProps>((props) => {
  const { variantStyle = 'primary', theme, active, fullWidth } = props;
  return {
    flexDirection: 'column',
    width: fullWidth ? '100%' : 'unset',
    ...(variantStyle === 'primary' && {
      ...theme.typography.button,
      padding: '32px 56px',
      background: theme.palette.juicy_orange_grad,
      borderRadius: 40,
      color: theme.palette.warm_black,
      border: `2px solid ${theme.palette.glass_yellow_border_grad}`,
      position: 'relative',
      overflow: 'hidden',
      transition: 'color 0.25s ease',
      boxShadow: '0 16px 40px 0 rgba(0, 0, 0, 0.15), 0 -4px 12px 0 rgba(0, 0, 0, 0.15) inset, 0 8px 16px 0 rgba(255, 255, 255, 0.40) inset',

      '&.Mui-disabled': {
        border: 'unset',
        opacity: 0.5,
        color: theme.palette.warm_black,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        boxShadow: '0 16px 40px 0 rgba(255, 153, 0, 0.40), 0 -4px 12px 0 rgba(0, 0, 0, 0.15) inset, 0 8px 16px 0 rgba(255, 255, 255, 0.40) inset',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: 0,
        transition: 'opacity 0.25s ease',
      },
      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          background: theme.palette.juicy_hover_grad,
          '&::after': {
            opacity: 1,
          },
        },
      },
    }),

    ...(variantStyle === 'secondary' && {
      textTransform: 'none',

      ...theme.typography.button_alt,
      padding: '40px',
      background: theme.palette.white_to_white_grad,
      borderRadius: 24,
      color: theme.palette.dark,

      ...(active && {
        border: `4px solid ${theme.palette.green_glass_border_grad}`,
        background: theme.palette.juicy_green_grad,
        boxShadow: `0 4px 32px 0 ${theme.palette.accent}`,
      }),
      '&.Mui-disabled': {
        opacity: 0.5,
        color:'black',
      },
    }),
    ...(variantStyle === 'text' && {
      borderRadius: 24,
      flexDirection:'row',
      color:theme.palette.white_90,
      gap:4,
      px:10,
      py:8,
      alignItems:'center',
      background: 'transparent',
    }),
  };
});

export type IconButtonVariantStyle = 'primary' | 'secondary'
export type StyledIconButtonProps = {
  variantStyle?: IconButtonVariantStyle;
};

export const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'variantStyle',
})<StyledIconButtonProps>(({ theme }) => {

  return ({
    background: theme.palette.white_to_white_grad,
    borderRadius: 32,
    color: 'black',
    width: 144,
    height: 144,
    p: 10,
  });
});